module.exports = __webpack_public_path__ + "img/img25.3b490ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/07/img25.jpg
// module id = 291
// module chunks = 0